import { saveCalendarPublishingPermissions } from '../actions/calendarPublishing';
import getStore from '../store/publishingStore';
import PublishedCalendar from '../store/schema/PublishedCalendar';
import PublishingPermissionItemState from '../store/schema/PublishingPermissionItemState';
import { mutator } from 'satcheljs';

export default mutator(saveCalendarPublishingPermissions, msg => {
    let viewState = getStore().viewState;

    if (viewState) {
        const { calName, primaryColor, folderId } = msg;
        let publishingItems: PublishingPermissionItemState[] = msg.publishingPermissionItemStates;

        let publishedCal: PublishedCalendar = {
            calName: calName,
            primaryColor: primaryColor,
            itemStates: publishingItems,
        };
        viewState.publishedCalendarsMap.set(folderId, publishedCal);
    }
});
